// extracted by mini-css-extract-plugin
export var dataCell = "_qb-2";
export var dataRow = "_qb-0";
export var headerRow = "_qb-1";